import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseHref } from "service/api";
type SettingsResponse = {
  settings: {
    name: string;
    value: string;
  }[];
  result: boolean;
};
export const settingsApi = createApi({
  reducerPath: "settingsApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${baseHref}/settings`,
    credentials: "include",
  }),
  tagTypes: ["Settings"],
  endpoints: (builder) => ({
    getSettings: builder.query<SettingsResponse, void>({
      query: () => ``,
    }),
  }),
});
export const { useGetSettingsQuery } = settingsApi;
